import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoriesAPI, citiesAPI } from '../services/api';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    categoriesAPI.getAll().then(res => setCategories(res.data.slice(0, 8))).catch(() => {});
    citiesAPI.getAll().then(res => setCities(res.data.filter(c => c.is_main || c.isMain).slice(0, 6))).catch(() => {});
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                khadam<span className="text-blue-400">express</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Trouvez le prestataire idéal au Maroc. Services à domicile de qualité en toute confiance.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">Services</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Villes */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">Villes</h4>
            <ul className="space-y-2">
              {cities.map((city) => (
                <li key={city.id}>
                  <Link
                    to={`/category/menage`}
                    className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-1.5"
                  >
                    <MapPin size={12} />
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <Phone size={14} />
                  +212 5XX-XXXXXX
                </a>
              </li>
              <li>
                <a href="mailto:info@khadamexpress.com" className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <Mail size={14} />
                  info@khadamexpress.com
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-3 text-gray-300">Télécharger</h4>
              <div className="flex flex-col gap-2">
                <button className="bg-gray-800 hover:bg-gray-700 text-white text-xs rounded-lg px-3 py-2 transition-colors text-left">
                  App Store
                </button>
                <button className="bg-gray-800 hover:bg-gray-700 text-white text-xs rounded-lg px-3 py-2 transition-colors text-left">
                  Google Play
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-500">
              © 2025 Khadam Express. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
                Conditions générales
              </a>
              <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
                Politique de confidentialité
              </a>
              <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
                Mentions légales
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
